import { DOC_TYPES, type DocType } from '@/pages/safe/docs/types';
import { JOURNAL_TYPES, type JournalType } from '@/pages/safe/safeJournalApi';

/**
 * 현장 세부 메뉴 — 대시보드 [입장] 이 여는 자리(DOC-135 · DOC-136). 묶음과 차례는 세이프유 웍스 현장 메뉴를 따르고
 * 지은 화면만 싣는다(DOC-136 §2 · 없는 화면의 칸은 세우지 않는다). 일지 · 양식 문서는 전체 화면과 같은 화면에 현장만 고정한다.
 */
export const SITE_JOURNALS: JournalType[] = [
  'PATROL',
  'JOINT',
  'EDUCATION',
  'HEALTH',
  'RISK',
  'TBM',
  ...(Object.keys(DOC_TYPES) as DocType[]),
];

type Item = { key: string; label: string };

const journal = (type: JournalType): Item => ({ key: JOURNAL_TYPES[type].path.slice(1), label: JOURNAL_TYPES[type].label });

export const SITE_MENU_GROUPS: Array<{ label: string | null; items: Item[] }> = [
  { label: null, items: [{ key: 'home', label: '홈' }] },
  { label: '안전보건경영', items: [journal('POLICY'), journal('ORG'), journal('COST')] },
  { label: '위험성평가', items: [journal('RISK'), journal('RISK_PLAN'), journal('RISK_MEETING'), journal('HAZARD_SURVEY')] },
  {
    label: '현장 점검 및 조치',
    items: [
      journal('DAILY_CHECK'),
      journal('WEEKLY_CHECK'),
      journal('JOINT'),
      journal('TBM'),
      journal('PATROL'),
      journal('HEALTH'),
      { key: 'near-miss', label: '아차사고일지' },
      { key: 'actions', label: '시정조치' },
      { key: 'vendor-tbm', label: '협력사 TBM' },
    ],
  },
  { label: '안전 작업 관리', items: [journal('WORK_PLAN'), journal('PERMIT')] },
  { label: '소통 및 교육 관리', items: [journal('COUNCIL'), journal('EDUCATION')] },
  { label: '비상시 대비 및 대응', items: [journal('SCENARIO'), journal('DRILL'), journal('ACCIDENT')] },
  { label: '근로자 의견 청취', items: [{ key: 'voice', label: '근로자 의견 청취' }] },
  {
    label: '온열질환 관리',
    items: [
      { key: 'heat-status', label: '전체 현황' },
      journal('HEAT_CHECK'),
      journal('HEAT_ACCIDENT'),
      { key: 'heat-zones', label: '구역 및 환경 설정' },
    ],
  },
  {
    label: '보관',
    items: [
      { key: 'legacy', label: '기존 데이터' },
      { key: 'photos', label: '사진 타임라인' },
      { key: 'cases', label: '조치 사례' },
    ],
  },
];

/** 현장 화면의 주소. 기본은 현장 홈. */
export function sitePath(siteId: string, key = 'home'): string {
  return `/sites/${encodeURIComponent(siteId)}/${key}`;
}
